module.exports = __webpack_public_path__ + "assets/img/NPC033.5ebbc498.png";